import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Material imports
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';

// Shared components
import { SpecialtyIntakeDisplayComponent } from '../components/specialty-intake-display/specialty-intake-display.component';
import { NotificationBellComponent } from '../../components/_shared/notification-bell/notification-bell.component';
import { NotificationCenterComponent } from '../../components/_shared/notification-center/notification-center.component';
import { SharedSupportComponent } from '../../components/_shared/support/shared-support.component';
import { TicketDetailsModalComponent } from '../../components/_shared/support/ticket-details-modal/ticket-details-modal.component';
import { CreateTicketModalComponent } from '../../components/_shared/support/create-ticket-modal/create-ticket-modal.component';
import { HelpArticleViewDialogComponent } from '../../components/_shared/support/help-article-view-dialog/help-article-view-dialog.component';
import { ReleaseNotesPopupComponent } from '../../components/_shared/support/release-notes-popup/release-notes-popup.component';
import { SystemMessageBannerComponent } from '../../components/_shared/system-message-banner/system-message-banner.component';

@NgModule({
  declarations: [
    NotificationBellComponent,
    NotificationCenterComponent,
    SharedSupportComponent,
    TicketDetailsModalComponent,
    CreateTicketModalComponent,
    HelpArticleViewDialogComponent,
    ReleaseNotesPopupComponent,
    SystemMessageBannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTooltipModule,
    MatDialogModule,
    MatPaginatorModule,
    MatTabsModule,
    SpecialtyIntakeDisplayComponent
  ],
  exports: [
    SpecialtyIntakeDisplayComponent,
    NotificationBellComponent,
    NotificationCenterComponent,
    SharedSupportComponent,
    SystemMessageBannerComponent,
    // Export Material modules so they're available to components using this module
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class SpecialtySharedModule { }
